
import "./nav.css";
import imagenes from "../../assets/Imagenes";
import "../../styles/index.css"

function Nav() {
    return <nav className="nav-banner">
        <section className="section-todas-pesnias">
            <img src={imagenes.op7} className="banner-todas-pestanias" alt="" />
        </section>
    </nav>;
}
export default Nav; 